module.exports = __webpack_public_path__ + "cert-iisbinding.8bdff35f5bcadb4b43b6e16f6006c64c.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-iisbinding.png
// module id = 7523386370164105
// module chunks = 1